var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"10px"}},[_c('BaseBoardSubTitle',{attrs:{"name":_vm.title}}),_c('div',{staticStyle:{"border":"1px solid var(--border)","padding":"10px 5px"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }